import TabRouter from "core/layout/presenter/TabRouter";
import { withRouter } from "react-router-dom";
import connectExtraProps from "core/shared/util/connectExtraProps";
import _ from "lodash";

export default _.flowRight(
  withRouter,
  connectExtraProps({ selectedPath: "location.pathname" })
)(TabRouter);
